var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.454,
    cy: 377,
    rx: 14.59,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.454 275.75c8.284 0 15-6.716 15-15v-170c0-8.284-6.716-15-15-15s-15 6.716-15 15v170c0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.178,
    cy: 377,
    rx: 14.59,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.178 275.75c8.284 0 15-6.716 15-15v-170c0-8.284-6.716-15-15-15s-15 6.716-15 15v170c0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.678 474.124-81.416-461.726c-1.439-8.158-9.218-13.606-17.377-12.167l-101.245 17.852c-2.744-3.025-6.694-4.937-11.101-4.937h-233.446c-8.284 0-15 6.716-15 15l-.001 468.854c0 3.979 1.58 7.794 4.394 10.606 2.813 2.814 6.627 4.394 10.606 4.394h233.448c8.284 0 15-6.716 15-15v-290.278l51.643 292.88c1.439 8.158 9.218 13.606 17.377 12.167l114.951-20.269c8.158-1.438 13.605-9.218 12.167-17.376zm-342.862 7.876h-86.724v-30h86.724zm0-60h-86.724l.001-378.854h86.723zm116.724 60h-86.724v-30h86.724zm0-60h-86.724v-378.854h86.723v378.854zm98.164-1.466-65.787-373.096 85.406-15.058 65.787 373.096zm10.418 59.087-5.209-29.542 85.406-15.059 5.209 29.543z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.593,
    cy: 368.689,
    rx: 14.59,
    ry: 15,
    transform: "matrix(.985 -.174 .174 .985 -58.053 73.767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.178 251.599-29.52-167.416c-1.439-8.159-9.219-13.606-17.377-12.167-8.158 1.439-13.606 9.219-12.167 17.377l29.52 167.416c1.439 8.159 9.219 13.606 17.377 12.167s13.606-9.219 12.167-17.377z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.29760ff1038a3bc478931ca1d3616434.svg";
export { ForwardRef as ReactComponent };